// document.addEventListener('DOMContentLoaded', () => {
//   if (window.innerWidth < 990) return;

//   document.querySelectorAll('header-menu').forEach(wrapper => {
//     const menu = wrapper.querySelector('details.mega-menu');
//     if (!menu) return;

//     let timeout;

//     wrapper.addEventListener('mouseenter', () => {
//       clearTimeout(timeout);
//       menu.setAttribute('open', '');
//     });

//     wrapper.addEventListener('mouseleave', () => {
//       timeout = setTimeout(() => {
//         menu.removeAttribute('open');
//       }, 200);
//     });
//   });
// });
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return;

  document.querySelectorAll('header-menu').forEach(wrapper => {
    const menu = wrapper.querySelector('details.mega-menu');
    const summary = menu?.querySelector('summary');

    if (!menu || !summary) return;

    let timeout;

    wrapper.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      menu.setAttribute('open', '');
    });

    wrapper.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        menu.removeAttribute('open');
      }, 200);
    });

    const link = wrapper.closest('li')?.querySelector('a[href]');

    if (link) {
      summary.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        window.location.href = link.href;
      });
    }
  });
});
